export default {
    euro(e){
        let f = new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: 'EUR',
          });
        return f.format(e / 100);
    }
}